import { createAction, props } from '@ngrx/store';
import { PaymentType } from 'src/app/core/enums/enums';
import { PaymentResponse } from 'src/app/core/models/PaymentResponse';
import {
  CreditCard,
  PaymentForm,
  PaymentMethod,
  ReissueRequestStatus
} from 'src/app/core/models/reissue.model';
import { ExchangeQuoteRequest } from 'src/app/core/models/voluntary-change.model';

export const LoadPaymentMethods = createAction(
  '[Reissue] Load Payment Methods',
  props<{ paymentMethods: PaymentMethod[] }>()
);

export const Payment = createAction(
  '[Reissue] Execute Payment',
  props<{ paymentType: PaymentType; formData: CreditCard; isPaymentFirst: boolean }>()
);

export const PaymentSuccess = createAction(
  '[Reissue] Payment Success',
  props<{
    paymentResult: PaymentResponse;
    formOfPayment: PaymentForm;
    quote: ExchangeQuoteRequest;
    isPaymentFirst: boolean;
  }>()
);

export const PaymentFail = createAction(
  '[Reissue] Payment Fail',
  props<{ requestStatus: ReissueRequestStatus }>()
);

export const ResetPaymentForm = createAction('[Reissue] Reset payment form');
